import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app.component';
import { routes } from './app.routes';

// services
import { StorageService } from './_services/storage.service';
import { WebServicesService } from './_services/webservices.service';
import { ApiService } from './_services/api/_api.service';
import { DialogService } from './_services/dialog.service';
import { FilesService } from './_services/files.service';
import { SearchService } from './_services/search.service';
import { SortService } from './_services/sort.service';
import { SanitizerService } from './_services/sanitizer.service';
import { DateParserService } from './_services/dateparser.service';

// authguards
import { UserAuthGuard } from './_routeguards/user.authguard';
import { DatatableModule } from './shared';
import { AuthInterceptor, AuthModule } from 'angular-auth-oidc-client';
import { AuthConfig } from './auth.config';
import { HttpErrorInterceptor } from './_services/api/_http-error.interceptor';

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        DatatableModule,
        routes,
        AuthModule.forRoot({ config: AuthConfig }),
    ],
    providers: [
        StorageService,
        WebServicesService,
        ApiService,
        FilesService,
        SearchService,
        SortService,
        SanitizerService,
        DialogService,
        DateParserService,
        UserAuthGuard,

        provideHttpClient(withInterceptorsFromDi()),
        
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },

    ]
})
export class AppModule { }
